export function maskedTelInputs() {
  const inputs = document.querySelectorAll('input[type="tel"]');
  inputs.forEach(element => {
    Inputmask({ mask: '+1 (999) 999-9999', autoUnmask: true }).mask(element);
  });
}
